import { translations } from 'locales/translations';
import { _t } from 'helpers/messages';

export const messages = {
  step1: () =>
    _t(translations.pages.Instructions.step1, 'Step 1. Install the app.'),
  step2: () =>
    _t(
      translations.pages.Instructions.step2,
      'Step 2. Create an account and join the program.',
    ),
  step3: () =>
    _t(
      translations.pages.Instructions.step3,
      'Step 3. Complete the process and enjoy your journey to better health!',
    ),
  step1Description: () =>
    _t(
      translations.pages.Instructions.step1Description,
      'Download the RNI Health App to your smartphone. Use one of the below options.',
    ),
  step2Description: () =>
    _t(
      translations.pages.Instructions.step2Description,
      'Join by clicking the button in your email.',
    ),
  step3Description: () =>
    _t(
      translations.pages.Instructions.step3Description,
      'Follow the instructions in the app and explore the content we’ve prepared for you.',
    ),
  downloadApp: () =>
    _t(
      translations.pages.Instructions.downloadApp,
      'Download the mobile app from your preferred app store below.',
    ),
  contactSupport: () =>
    _t(translations.pages.Instructions.contactSupport, 'Contact Support'),
};
